import { createCustomFlowplayerPlaylistUi } from "./custom-flowplayer-playlist-ui-controls";
import {
  FlowplayerPlaylistQueue,
  onFlowplayerPlaylistReady,
} from "./custom-flowplayer-playlist-ui-load";
import { isPreviewSystem } from "../../utils/featureFlag";

onFlowplayerPlaylistReady((globalFlowplayer, localFlowplayer) => {
  const globalPlaylist = globalFlowplayer.playlist;
  const localPlaylist = localFlowplayer.playlist;

  if (
    !localFlowplayer.root.classList.contains("js-custom-flowplayer-playlist-ui")
  ) {
    return;
  }

  if (!globalPlaylist || !localPlaylist) {
    return;
  }

  const playerMiddleElement =
    localFlowplayer.root.querySelector("flowplayer-middle")!;

  const handleSelectInCustomUi: Parameters<
    typeof createCustomFlowplayerPlaylistUi
  >[2] = (index, updateActiveQueueElement) => {
    updateActiveQueueElement();

    localPlaylist.play(index);
  };

  let customUi = createCustomFlowplayerPlaylistUi(
    localPlaylist.queue,
    localFlowplayer.root.dataset["headline"] ?? "",
    handleSelectInCustomUi
  );

  const updateCustomUiVisibility = () => {
    const showPlaylistWithoutHover =
      localFlowplayer.root.dataset["showPlaylistWithoutHover"] === "1";

    if (
      (isPreviewSystem() &&
        showPlaylistWithoutHover &&
        (localFlowplayer.paused || !localFlowplayer.started)) ||
      localFlowplayer.playerState["is-touched"] ||
      localFlowplayer.playerState["is-hovered"]
    ) {
      customUi.show();
    } else {
      customUi.hide();
    }
  };
  updateCustomUiVisibility();
  playerMiddleElement.after(customUi.node);

  localFlowplayer.on(globalPlaylist.events.PLAYLIST_READY, (event) => {
    customUi.node.remove();
    customUi = createCustomFlowplayerPlaylistUi(
      "queue" in event &&
        typeof event.queue === "object" &&
        event.queue !== null
        ? (event.queue as FlowplayerPlaylistQueue)
        : localPlaylist.queue,
      localFlowplayer.root.dataset["headline"] ?? "",
      handleSelectInCustomUi
    );
    updateCustomUiVisibility();
    playerMiddleElement.after(customUi.node);
  });

  const availableEvents = globalFlowplayer.events;

  if ("STATE" in availableEvents) {
    localFlowplayer.on(availableEvents["STATE"], updateCustomUiVisibility);
  } else {
    // eslint-disable-next-line no-console
    console.error("STATE event isn't available.");
  }
});
